import { Option } from 'owa-options-core';
import * as React from 'react';
import { discardGuidedCaptureOptions } from '../lib/actions/guidedCaptureOptionActions';
import GuidedCaptureFull from './components/GuidedCaptureFull';
import areGuidedCaptureOptionsDirty from './utils/areGuidedCaptureOptionsDirty';
import { isFeatureEnabled } from 'owa-feature-flags';
import saveGuidedCaptureOptions from './orchestration/saveGuidedCaptureOptions';

let GuidedCaptureOption: Option = {
    key: 'GuidedCaptureOption',
    titleStringKey: 'optionTitle_guidedCapture',
    searchTermsStringKey: 'optionTitle_guidedCapture',
    fullOptionFormSettings: {
        render: () => <GuidedCaptureFull />,
        isDirty: areGuidedCaptureOptionsDirty,
        onSave: saveGuidedCaptureOptions,
        onDiscard: discardGuidedCaptureOptions,
    },
    isHidden: () => !isFeatureEnabled('cal-intelligenceOption'),
};

export default GuidedCaptureOption;
